import React from 'react';
import { ExportCta } from '../context/DataContext';
import Button from './Button';
import Icon from './Icon';
import Tag from './Tag';

interface QACardProps {
  title: string;
  description: string;
  tags?: Array<React.ReactElement<typeof Tag>>;
  callToActions?: ExportCta[];
}

function QACard(props: QACardProps) {
  const { title, description, tags, callToActions, ...rest } = props;

  const showCallToActions = callToActions && callToActions.length > 0;

  return (
    <div {...rest}>
      <div className="flex items-baseline space-x-2 text-lg px-4 pt-4 pb-2">
        <Icon icon={['far', 'question-circle']} />
        <span className="font-semibold card-title">{title}</span>
      </div>
      <div className="bg-white border border-slate-300 ml-4 p-3 border-r-0">
        <div style={{ left: '1rem' }} className="flex space-x-1 mb-1">
          {tags}
        </div>
        <div
          className="leading-snug card-html card-subtitle"
          dangerouslySetInnerHTML={{ __html: description }}
        ></div>
        {showCallToActions && (
          <div className="flex space-x-2 mt-3 text-sm">
            {(callToActions || []).map((e, index) => (
              <a key={index} href={e.link} target={e.target}>
                <Button outline="border-blue-500" shape="oval" className="text-blue-500 text-sm">
                  {e.label}
                </Button>
              </a>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default QACard;
